import MonthCard from "../MonthCard";

function MonthsContainer({ months, ...props }) {
  return (
    <div
      className="bg-white rounded-3 shadow-sm border-1 border-primary"
      style={{
        overflow: "hidden",
      }}
    >
      <div className="row g-3 p-2 px-md-5 py-md-4">
        {months.map((month) => (
          <MonthCard key={month} month={month} {...props} />
        ))}
      </div>
    </div>
  );
}

export default MonthsContainer;
